import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-expprombez',
  templateUrl: './expprombez.component.html',
  styleUrls: ['./expprombez.component.scss']
})
export class ExpprombezComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
